import Box from "@mui/material/Box";
import PropTypes from "prop-types";

export default function A11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
